module.exports = __webpack_public_path__ + "img/preloader-analytic.24695e1b.svg";